import { render } from "./DotsProgress.vue?vue&type=template&id=1cc354c4&scoped=true"
import script from "./DotsProgress.vue?vue&type=script&lang=ts"
export * from "./DotsProgress.vue?vue&type=script&lang=ts"

import "./DotsProgress.vue?vue&type=style&index=0&id=1cc354c4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1cc354c4"

export default script